export const PRODUCTS_REQUEST="getProducts";
export const PRODUCT_SUCCESS="productSuccess";
export const PRODUCT_ERROR="productError";
export const PRODUCT_ADD="productAdd";
export const PRODUCT_DELETE="productDelete";
export const PRODUCT_UPDATE="productUpdate";
export const INCREASE_PAGE="increasePage";
export const GET_TOTAL_PRODUCTS="getTotalProducts";
export const GET_LIMITED_PRODUCTS="getLimited"